<template>
  <div class="aftersales_main">
    <el-form :inline="true" label-width="120px">
      <el-form-item label="仓名查询">
        <el-input v-model="form.stockName" placeholder="请输入仓名"></el-input>
      </el-form-item>
      <el-form-item label="仓级筛选：">
        <el-select v-model="form.level">
          <el-option :value="null" label="全部"></el-option>
          <el-option :value="1" label="一级"></el-option>
          <el-option :value="2" label="二级"></el-option>
          <el-option :value="3" label="三级"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域查询">
        <el-input
          v-model="form.deliverArea"
          placeholder="请输入区域"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">筛选</el-button>
        <el-button @click="onEmpty">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table_box">
      <el-table :data="multistageStockSkuList" border>
        <el-table-column
          fixed
          label="id"
          align="center"
          prop="Id"
          width="80"
        ></el-table-column>
        <el-table-column
          label="仓名"
          align="center"
          prop="StockName"
          width="200"
        ></el-table-column>
        <el-table-column
          label="仓级"
          align="center"
          prop="StockLevel"
          width="80"
        ></el-table-column>
        <el-table-column
          label="发货区域"
          prop="DeliverAreaName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="库存量"
          align="center"
          prop="StockNum"
          width="80"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="300">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleSubmit(scope.row)"
              >库存编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="total"
        background
        @current-change="handleCurrentChange"
        style="float:right;"
        :current-page="form.pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  Product_MultistageStockSkuList,
  Product_MultistageStockSkuUpdateStockNum,
} from "../../../api/api";
export default {
  props: ["skuId"],
  data() {
    return {
      multistageStockSkuList: [],
      total: 0,
      form: {
        stockName: null,
        level: null,
        skuId: null,
        deliverArea: null,
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.form.skuId = this.skuId;
    this.getProduct_MultistageStockSkuList();
  },
  methods: {
    getProduct_MultistageStockSkuList() {
      Product_MultistageStockSkuList(this.form).then((res) => {
        if (res.data.success) {
          this.multistageStockSkuList = res.data.response.data;
          this.total = res.data.response.dataCount || 0
        }
      });
    },
    onSubmit() {
      this.getProduct_MultistageStockSkuList();
    },
    onEmpty() {
      this.form = {
        stockName: null,
        level: null,
        deliverArea: null,
        skuId: this.skuId,
        pageIndex: 1,
        pageSize: 10,
      };
      this.getProduct_MultistageStockSkuList();
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getProduct_MultistageStockSkuList();
    },
    handleSubmit(row) {
      console
      this.$prompt("请输入库存", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        let data = {
          id: row.Id,
          stockNum: value
        }
        Product_MultistageStockSkuUpdateStockNum(data).then(res=>{
          if(res.data.success) {
            this.$message.success(res.data.msg)
            this.getProduct_MultistageStockSkuList();
            this.$parent.$parent.getProduct_MultistageStockSkuList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      });
    },
  },
};
</script>

<style scoped>
.aftersales_main {
  padding: 0 20px 20px 20px;
}
.aftersales_main > .el-form {
  background: #ebeef5;
  padding: 20px 20px 0 20px;
  margin-bottom: 20px;
}
</style>